import { Entity, formatTicker, mapAssetClass } from '@api';
import { DropdownListItem } from '@design/components/dropdown/dropdown-list-item/DropdownListItem';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { FlagIcon } from '@terminal/components/flag-icon/FlagIcon';
import { TruncateTooltip } from '@terminal/components/truncate-tooltip/TruncateTooltip';
import { useTranslation } from 'react-i18next';

import styles from './EntityDropdownItem.module.scss';

export const EntityDropdownItem = ({
  entity,
  isActive,
  isFocused,
}: {
  entity: Entity;
  isActive: boolean;
  isFocused: boolean;
}) => {
  const { t } = useTranslation(['analyze']);
  const { sub_class } = mapAssetClass(entity);

  return (
    <div className={styles.dropdownListItemWrapper}>
      <DropdownListItem
        label={
          <div className={styles.root}>
            <div className={styles.leftWrapper}>
              <AssetLogoContainer
                className={styles.styledAssetLogoContainer}
                size={32}
                entity={entity}
              />
              <div className={styles.titleAndSubtitleWrapper}>
                <span className={styles.tickerLabel}>
                  {formatTicker(entity)}
                </span>
                <TruncateTooltip
                  text={entity.name}
                  truncatedLabelWrapper={
                    <span className={styles.nameLabel}>{entity.name}</span>
                  }
                  fallbackLabel={
                    <span className={styles.nameLabel}>{entity.name}</span>
                  }
                  atLength={40}
                />
              </div>
            </div>
            <div className={styles.rightWrapper}>
              <div className={styles.exchangeAndClassWrapper}>
                <span className={styles.exchangeLabel}>
                  {entity.exchange.code.toUpperCase()}
                </span>
                {sub_class && (
                  <span className={styles.assetClassLabel}>
                    {t(`analyze:assetSubClass.${sub_class}`)}
                  </span>
                )}
              </div>
              <FlagIcon
                countryCode={entity.trading_country?.long}
                variant="circular"
                customSize={24}
              />
            </div>
          </div>
        }
        isActive={isActive}
        isFocused={isFocused}
      />
    </div>
  );
};
